import {CommonModule} from '@angular/common';
import {Component, inject} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {MatIconModule} from '@angular/material/icon';
import {TranslateModule} from '@ngx-translate/core';
import {ActivitiesSearchEngineModule} from '@modules/activities/core/activities-search-engine';
import {ActivitiesSharedModule} from '@modules/activities/core/activities-shared.module';
import {ActivitySearchOptions} from '@modules/activities/core/activities-search-engine/activity-search-options';
import {
    SearchFilterSelection,
    SearchFilterValue,
} from 'shared/search-engine';
import {MathiaSearchDataService} from '../mathia-search-data.service';
import {MathiaGenericSearchFilterComponent} from '../mathia-generic-search-filter/mathia-generic-search-filter.component';

@Component({
    selector: 'app-mathia-activity-search-dialog',
    standalone: true,
    imports: [
        CommonModule,
        MatButtonModule,
        MatDialogModule,
        MatIconModule,
        ActivitiesSearchEngineModule,
        ActivitiesSharedModule,
        MathiaGenericSearchFilterComponent,
        TranslateModule,
    ],
    templateUrl: './mathia-activity-search-dialog.component.html',
})
export class MathiaActivitySearchDialogComponent {
    private readonly dialogRef = inject(MatDialogRef<MathiaActivitySearchDialogComponent>);
    private readonly searchData = inject(MathiaSearchDataService);

    public selection: SearchFilterSelection<SearchFilterValue> = {};
    public activitySearchOptions: ActivitySearchOptions = {filters: {}};
    private selectedActivityIds = new Set<string | number>();

    public onSelectionChange(selection: SearchFilterSelection<SearchFilterValue>): void {
        this.selection = {...selection};
        this.selectedActivityIds.clear();
        this.activitySearchOptions = {
            filters: this.searchData.toBasicSearchFilters(this.selection),
        };
    }

    public toggleActivity(id: string | number): void {
        if (this.selectedActivityIds.has(id)) {
            this.selectedActivityIds.delete(id);
        } else {
            this.selectedActivityIds.add(id);
        }
    }

    public isSelected(id: string | number): boolean {
        return this.selectedActivityIds.has(id);
    }

    public get selectedActivityCount(): number {
        return this.selectedActivityIds.size;
    }

    public clearSelection(): void {
        this.selectedActivityIds.clear();
    }

    public close(): void {
        this.dialogRef.close([...this.selectedActivityIds]);
    }
}
